import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(id) {
    const response = await api.fetch(`/api/v2/booking/import`, {
      method: 'POST',
      body: JSON.stringify({
        id_integration: id
      })
    })
    return await handleResponse(response)
  }
}
